/**
 * Indicador flutuante de carregamento de camadas (zoneamento, dados censitários…).
 * Essas camadas demoram e, sem feedback, o usuário não sabe se deu erro ou se ainda
 * está carregando. É uma pilha de rótulos: o último entrado é o exibido.
 *
 * Compartilhado entre os mapas Mapbox — o hospedeiro só precisa ter `layerLoading`
 * no estado e renderizar `<LayerLoadingIndicator labels={this.state.layerLoading} />`.
 */

export const LAYER_LOADING_INITIAL_STATE = {
    layerLoading: [],
};

export function beginLayerLoading(self, label) {
    self.setState((prev) => ({ layerLoading: [...prev.layerLoading, label] }));
}

export function endLayerLoading(self, label) {
    self.setState((prev) => {
        const next = [...prev.layerLoading];
        const idx = next.indexOf(label);
        if (idx !== -1) next.splice(idx, 1);
        return { layerLoading: next };
    });
}
